<h1 mat-dialog-title class="p-2 text-center">Conformité du processus</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Nom</mat-label>
            <input matInput [(ngModel)]="Model.Name" placeholder="Nom">
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Sous-section</mat-label>
            <mat-select [(ngModel)]="Model.SubSection" placeholder="Sous-section">
                @for (s of SubSectionList; track s; let i = $index) {
                <mat-option [value]="i + 1">
                    {{ s }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Charge en poussière attendue</mat-label>
            <mat-select [(ngModel)]="Model.DustLoadType" placeholder="Charge en poussière attendue">
                @for (d of DustLoadTypeList; track d; let i = $index) {
                <mat-option [value]="i + 1">
                    {{ d }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Niveau de poussière</mat-label>
            <mat-select placeholder="Niveau de poussière" [(ngModel)]="Model.DustLevel">
                @for (level of DustLevel; track level) {
                <mat-option [value]="level">
                    {{level}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Tr du processus</mat-label>
            <input matInput [(ngModel)]="Model.ProcessCalculation.Duration" placeholder="Tr du processus" readonly>
        </mat-form-field>
    </div>

    <h3 class="col-12 text-center">MPCE </h3>
    <!-- <div *ngFor="let t of Model.EnvCollectiveMeansOfPreventionList" class="row">
  <div class="col-12">{{t.Name}}</div>
</div> -->
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Confinement Statique</mat-label>
            <mat-select [(ngModel)]="SelectedMPCEList" placeholder="Confinement Statique" (selectionChange)="SelectionChanged($event)" panelClass="width-mat" multiple>
                @for (mpce of MPCEList; track mpce) {
                <mat-option [value]='mpce'>
                    {{ mpce }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Valeur de renouvellement d'air (Vol/H)</mat-label>
            <input matInput type="text" inputmode="numeric" (keydown)="checkCharacters($event)" [(ngModel)]="VolumeAirString" placeholder="Valeur de renouvellement d'air (Vol/H)"
                [required]=" isVolumeMandatory() ">
            @if (!validCharacters() && VolumeAirString !== '') {
            <span class="error">
                Saisir un nombre à une décimale
            </span>
            }
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Ventilation Globale</mat-label>
            <mat-select placeholder="Ventilation Globale" [(ngModel)]="Model.VentilationGlobale" required>
                @for (o of VentilationGlobaleList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <h3 class="col-12 text-center">Techniques </h3>
    @for (t of Model.ProcessTechniqueList; track t) {
    <div class="col-auto text-center">
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Technique Scola</mat-label>
                <mat-select [(ngModel)]="t.ScolaTechnique" placeholder="Technique Scola">
                    <mat-option value="Aucun">Aucun</mat-option>
                    @for (st of ScolaTechniqueList; track st) {
                    <mat-option [value]='st'>
                        {{ st }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        @if (t.Mpca?.ScolaMaterial) {
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Matériel Scola</mat-label>
                <mat-select [(ngModel)]="t.Mpca.ScolaMaterial" placeholder="Matériel Scola">
                    <mat-option value="Aucun">Aucun</mat-option>
                    @for (sm of ScolaMaterialList; track sm) {
                    <mat-option [value]='sm'>
                        {{ sm }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Captage</mat-label>
                <mat-select [(ngModel)]="t.Catchment" placeholder="Captage">
                    <mat-option value="Aucun">Aucun</mat-option>
                    @for (c of CatchmentList; track c) {
                    <mat-option [value]='c'>
                        {{ c }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Humidification</mat-label>
                <mat-select [(ngModel)]="t.Humidification" placeholder="Humidification">
                    <mat-option value="Aucun">Aucun</mat-option>
                    @for (h of HumidificationList; track h) {
                    <mat-option [value]='h'>
                        {{ h }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Travail à l'humide</mat-label>
                <mat-select [(ngModel)]="t.HumidityWork" placeholder="Travail à l'humide">
                    <mat-option value="Aucun">Aucun</mat-option>
                    @for (hw of HumidityWorkList; track hw) {
                    <mat-option [value]='hw'>
                        {{ hw }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="my-3 mx-5" style="background: gray; height: 3px;"></div>
    </div>
    }
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Observation</mat-label>
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Model.Observation"
                placeholder="Observation"></textarea>
        </mat-form-field>
    </div>
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>